import { IconProps } from '@/core/global-data/dataInterface.data';

const People = ({ width = '20', height = '20', className = '' }: IconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 21 20"
            fill="none"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.7504 5.96651C15.7004 5.95817 15.6421 5.95817 15.5921 5.96651C14.4421 5.92484 13.5254 4.98317 13.5254 3.81651C13.5254 2.62484 14.4837 1.6665 15.6754 1.6665C16.8671 1.6665 17.8254 2.63317 17.8254 3.81651C17.8171 4.98317 16.9004 5.92484 15.7504 5.96651Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.8922 12.0333C16.0339 12.225 17.2922 12.025 18.1755 11.4333C19.3505 10.65 19.3505 9.36664 18.1755 8.58331C17.2839 7.99164 16.0089 7.79163 14.8672 7.99163"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.72539 5.96651C5.77539 5.95817 5.83372 5.95817 5.88372 5.96651C7.03372 5.92484 7.95039 4.98317 7.95039 3.81651C7.95039 2.62484 6.99206 1.6665 5.80039 1.6665C4.60873 1.6665 3.65039 2.63317 3.65039 3.81651C3.65872 4.98317 4.57539 5.92484 5.72539 5.96651Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.58353 12.0333C5.44186 12.225 4.18353 12.025 3.3002 11.4333C2.1252 10.65 2.1252 9.36664 3.3002 8.58331C4.19186 7.99164 5.46686 7.79163 6.60853 7.99163"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.7494 12.1916C10.6994 12.1833 10.6411 12.1833 10.5911 12.1916C9.44108 12.1499 8.52441 11.2083 8.52441 10.0416C8.52441 8.84994 9.48275 7.8916 10.6744 7.8916C11.8661 7.8916 12.8244 8.85827 12.8244 10.0416C12.8161 11.2083 11.8994 12.1583 10.7494 12.1916Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.32461 14.8168C7.14961 15.6001 7.14961 16.8835 8.32461 17.6668C9.65794 18.5585 11.8413 18.5585 13.1746 17.6668C14.3496 16.8835 14.3496 15.6001 13.1746 14.8168C11.8496 13.9335 9.65794 13.9335 8.32461 14.8168Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default People;
